<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal
        },
        computed: {
            getTitle() {
                return this.modalData.title || 'Confirmation';
            },
            getMsg() {
                return this.modalData.msg || 'Are you sure you want to do this action?';
            }
        },
        methods: {
            close() {
                if (this.modalData && this.modalData.onCancel) this.modalData.onCancel();

                modalService.closeModal();
            },
            ok() {
                if (this.modalData && this.modalData.onSuccess) this.modalData.onSuccess();

                modalService.closeModal();
            }
        }
    };
</script>

<template>
    <Modal>
        <form @submit.prevent="ok">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" v-html="getTitle"></h3>
                </div>
                <div class="modal-body pb-4">
                    <div class="mb-3" v-html="getMsg"></div>
                </div>

                <div class="modal-footer d-flex justify-content-between">
                    <button v-if="modalData.btnTextCancel !== false" type="button" class="btn" @click="close">
                        {{ modalData.btnTextCancel || 'Cancel' }}
                    </button>
                    <button v-if="modalData.btnTextOk !== false" type="submit" class="btn btn-outline-primary">
                        {{ modalData.btnTextOk || 'Yes' }}
                    </button>
                </div>
            </div>
        </form>
    </Modal>
</template>
